/**
 * Parker
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SettlementQuoteSource = {
    FrozenObligation: 'FrozenObligation',
    RepricedFromTariff: 'RepricedFromTariff',
    AlreadySettled: 'AlreadySettled',
    NotPriceable: 'NotPriceable',
    CoveredZero: 'CoveredZero',
    PaidWithinGrace: 'PaidWithinGrace'
} as const;
export type SettlementQuoteSource = typeof SettlementQuoteSource[keyof typeof SettlementQuoteSource];

